import Footer from "../../components/Footer/Footer";
import { Helmet } from "react-helmet";
import React, { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { A11y, Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import _ from "lodash";
import ReviewService from "../../services/ReviewService";
import { Alert } from "reactstrap";
import { Button } from "@mui/material";
import "./ReviewsPage.scss";
import Recaptcha from "react-recaptcha";
import {
  validateMessage,
  validateName,
} from "../../utilities/ValidationHelper";
import HomepageNavbar from "../../components/HomepageNavbar/HomepageNavbar";
import AlertStrings from "../../strings/AlertStrings.json";
import GeneralStrings from "../../strings/GeneralStrings.json";
import GeneralConst from "../../consts/GeneralConst";
import { ErrorMessage, Field, Form, Formik } from "formik";
import ReviewItem from "../../components/ReviewItem/ReviewItem";

const ReviewsPage = () => {
  const [reviews, setReviews] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [sentMessage, setSentMessage] = useState(false);
  const [failedMessage, setFailedMessage] = useState(false);
  const [recaptchaLoad, setRecaptchaLoad] = useState(false);
  const STATUS_CODES = GeneralConst.STATUS_CODES;
  const REVIEWS_STRINGS = GeneralStrings.REVIEWS;
  const TITLE = `${REVIEWS_STRINGS.BANNER_HEADING} | ${GeneralConst.SITE_NAME}`;

  const recaptchaLoaded = () => {
    setRecaptchaLoad(true);
  };

  const verifiedRecaptcha = (response) => {
    if (response) {
      setIsVerified(true);
    }
  };

  const resetErrorMessages = () => {
    setSentMessage(false);
    setFailedMessage(false);
  };

  const handleSubmit = (formValues) => {
    setIsLoading(true);
    resetErrorMessages();

    if (recaptchaLoad && isVerified) {
      ReviewService.addReview(formValues)
        .then((response) => {
          if (response.data.status === STATUS_CODES.ERROR) {
            setFailedMessage(
              response?.data?.statusMessage || AlertStrings.GENERAL_ERROR
            );
          } else {
            setSentMessage(
              response?.data?.statusMessage || AlertStrings.GENERAL_SUCCESS
            );
          }
        })
        .catch((response) => {
          setFailedMessage(
            response?.data?.statusMessage || AlertStrings.GENERAL_ERROR
          );
        })
        .finally(() => {
          setIsLoading(false);
        });
    }

    setIsLoading(false);
  };

  useEffect(() => {
    ReviewService.getAllReviews().then((response) => {
      const reviews = response?.data;
      setReviews(reviews);
    });
  }, [sentMessage]);

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <div className="reviews-page">
        <HomepageNavbar transparentNavbar={false} />
        <section className="page-banner">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-8 col-xl-7">
                <div className="banner-heading">
                  <h1>{REVIEWS_STRINGS.BANNER_HEADING}</h1>
                  <p className="banner-subheading">
                    {REVIEWS_STRINGS.BANNER_SUBTEXT}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="reviews-container">
          <div className="container">
            <Swiper
              autoplay={{ delay: 5000 }}
              modules={[Autoplay, Pagination, A11y]}
              spaceBetween={50}
              slidesPerView={1}
              pagination={{ clickable: true }}
              loop
            >
              {!_.isEmpty(reviews) &&
                reviews.map((review) => (
                  <SwiperSlide key={"review-" + review.id}>
                    <ReviewItem review={review} />
                  </SwiperSlide>
                ))}
            </Swiper>
            <hr />
            <div className="form-container">
              <h3 className="header">{REVIEWS_STRINGS.HEADER}</h3>
              {failedMessage && <Alert color="danger">{failedMessage}</Alert>}
              {sentMessage && <Alert>{sentMessage}</Alert>}
              <Formik
                className="form"
                initialValues={{
                  firstName: "",
                  lastName: "",
                  description: "",
                }}
                onSubmit={(values) => {
                  handleSubmit(values);
                }}
              >
                <Form className="row">
                  <div className="form-group col-sm-12 col-md-6">
                    <Field
                      name="firstName"
                      className="form-control"
                      placeholder={GeneralStrings.FORM.FORM_LABELS.FIRST_NAME}
                      validate={validateName}
                    />
                    <ErrorMessage
                      component="span"
                      className="form-error"
                      name="firstName"
                    />
                  </div>
                  <div className="form-group col-sm-12 col-md-6">
                    <Field
                      name="lastName"
                      className="form-control"
                      placeholder={GeneralStrings.FORM.FORM_LABELS.LAST_NAME}
                      validate={validateName}
                    />
                    <ErrorMessage
                      component="span"
                      className="form-error"
                      name="lastName"
                    />
                  </div>
                  <div className="form-group">
                    <Field
                      as="textarea"
                      name="description"
                      className="form-control"
                      placeholder={GeneralStrings.FORM.FORM_LABELS.MESSAGE}
                      validate={validateMessage}
                    />
                    <ErrorMessage
                      component="span"
                      className="form-error"
                      name="description"
                    />
                  </div>
                  <div className="form-group">
                    <Recaptcha
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                      render="explicit"
                      onloadCallback={recaptchaLoaded}
                      verifyCallback={verifiedRecaptcha}
                    />
                  </div>
                  <div className="form-group">
                    <Button
                      fullWidth
                      variant="contained"
                      disabled={isLoading}
                      loading={isLoading}
                      className="submit-btn"
                      type="submit"
                    >
                      {GeneralStrings.SUBMIT}
                    </Button>
                  </div>
                </Form>
              </Formik>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default ReviewsPage;
